import { HttpContextToken } from '@angular/common/http';

export const SHOULD_INTERCEPT = new HttpContextToken<boolean>(() => true);
